import { isOnline } from "./network";

const STORAGE_KEY = "pwa_catalog_v1";

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

// Lee cache local del catalogo.
export const readCache = () => {
  if (typeof window === "undefined") return null;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;

    const parsed = safeParse(stored);
    return Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    console.warn("No se pudo leer el cache del catalogo.", error);
    return null;
  }
};

// Escribe cache local del catalogo.
export const writeCache = (data) => {
  if (typeof window === "undefined") return;
  if (!Array.isArray(data)) return;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("No se pudo guardar el cache del catalogo.", error);
  }
};

// Devuelve cache si existe o array vacio.
export const getCatalog = () => readCache() || [];

// Refresca catalogo si hay conexion, usando un fetcher externo.
export const refreshCatalog = async (fetcher) => {
  if (!isOnline()) {
    return readCache() || [];
  }

  const result = await fetcher();
  if (Array.isArray(result)) {
    writeCache(result);
    return result;
  }

  return readCache() || [];
};
